document.addEventListener('DOMContentLoaded', () => {
  const faqs = document.querySelectorAll('.landing-faq-card');

  faqs.forEach(faq => {
    const trigger = faq.querySelector('.faq-intro');
    const panel = faq.querySelector('.faq-content');
    const icon = faq.querySelector('.faq-icon')

    if (!trigger || !panel) return;

    // Turning div into a semantic button
    if (trigger.tagName.toLowerCase() !== 'button') {
      trigger.setAttribute('role', 'button');
      if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
    }

    // Ensure aria-controls points to panel
    const panelId = panel.id || generateId('faq-panel-');
    panel.id = panelId;

    //a11y
    trigger.setAttribute('aria-controls', panelId);
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');

    trigger.addEventListener('click', () => toggle(trigger, panel, icon));

    // Keyboard (Enter / Space) for non-button triggers
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle(trigger, panel);
      }
    });
  });
});

function toggle(trigger, panel, icon) {
  const isOpen = trigger.getAttribute('aria-expanded') === 'true';
  if (isOpen) collapse(trigger, panel, icon);
  else expand(trigger, panel, icon);
}

function expand(trigger, panel, icon) {
  //Animate icon open
  icon.classList.add('faq-icon-open')
  
  // mark intent
  trigger.setAttribute('aria-expanded', 'true');
  panel.setAttribute('aria-hidden', 'false');

  // start from zero so transition runs
  panel.style.maxHeight = '0px';

  // force reflow
  panel.offsetHeight;

  // measure target height
  const target = panel.scrollHeight + 'px';
  panel.style.maxHeight = target;
  panel.classList.add('open');

  // clear max-height so layout can grow naturally
  const onEnd = () => {
    panel.style.maxHeight = 'none';
    panel.removeEventListener('transitionend', onEnd);
  };
  panel.addEventListener('transitionend', onEnd);
}

function collapse(trigger, panel, icon) {
  //reverse icon state
  icon.classList.remove('faq-icon-open')

  // set explicit height to current height >> for animation
  const current = panel.scrollHeight + 'px';
  panel.style.maxHeight = current;

  // force reflow
  panel.offsetHeight;

  // Neat trick as display none doesnt allow animations
  panel.style.maxHeight = '0px';

  // A11Y
  trigger.setAttribute('aria-expanded', 'false');

  // when collapsed, tidy up
  const onEnd = () => {
    panel.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true');
    panel.style.maxHeight = '';
    panel.removeEventListener('transitionend', onEnd);
  };
  panel.addEventListener('transitionend', onEnd);
}

// utility to create stable ids if needed
function generateId(prefix = '') {
  return prefix + Math.random().toString(36).slice(2, 9);
}
